import HttpHelpers from '../helpers';

const WishlistApiEndpoints = {
  getWishlist: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('wishlist/listing', { params })
      .then((response) => response.data);
  },
  addToWishlist: (listingId) => {
    return HttpHelpers.authenticatedAxios
      .post(`wishlist/listing/${listingId}`)
      .then((response) => response.data);
  },
  removeFromWishlist: (listingId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`wishlist/listing/${listingId}`)
      .then((response) => response.data);
  },
};

export default WishlistApiEndpoints;
